import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import ContactFormModal from './ContactFormModal';

const HeroSection = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <>
      <section className="relative bg-gradient-to-br from-slate-50 via-white to-indigo-50 py-20 overflow-hidden">
        {/* Decorative background pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 left-10 w-32 h-32 border-4 border-blue-800 rounded-lg"></div>
          <div className="absolute bottom-20 left-1/4 w-24 h-24 border-4 border-teal-500 rounded-lg"></div>
          <div className="absolute top-1/3 right-20 w-28 h-28 border-4 border-blue-800 rounded-lg"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left content */}
            <div className="space-y-8">
              <div>
                <h2 className="text-5xl md:text-6xl font-bold leading-tight">
                  <span className="text-blue-800">Private,</span>
                  <br />
                  <span className="text-gray-900">Secure Communication for Professionals</span>
                </h2>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-3 group transition-transform duration-300 hover:translate-x-2">
                  <Check className="h-6 w-6 text-teal-500 mt-1 flex-shrink-0" strokeWidth={3} />
                  <p className="text-lg text-gray-700">
                    Protect your communications with Encryptofy Mail, a fully encrypted email platform
                  </p>
                </div>

                <div className="flex items-start gap-3 group transition-transform duration-300 hover:translate-x-2">
                  <Check className="h-6 w-6 text-teal-500 mt-1 flex-shrink-0" strokeWidth={3} />
                  <p className="text-lg text-gray-700">
                    Run your professional email on a secure, privacy-first, tracker-free system
                  </p>
                </div>

                <div className="flex items-start gap-3 group transition-transform duration-300 hover:translate-x-2">
                  <Check className="h-6 w-6 text-teal-500 mt-1 flex-shrink-0" strokeWidth={3} />
                  <p className="text-lg text-gray-700">
                    Remove surveillance and tracking from your inbox completely
                  </p>
                </div>
              </div>
            </div>

            {/* Right illustration */}
            <div className="relative">
              <div className="relative z-10">
                <img
                  src="/assets/banner-img.png"
                  alt="Encryptofy Mail Banner"
                  className="w-full h-auto drop-shadow-2xl"
                />
              </div>
              
              {/* Background glow effect */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-800 rounded-full filter blur-3xl opacity-20 animate-pulse" style={{ animationDuration: '4s' }}></div>
            </div>
          </div>
        </div>
      </section>

      <ContactFormModal 
        isOpen={isContactOpen} 
        onClose={() => setIsContactOpen(false)}
        title="Get Started with Encryptofy Mail"
      />
    </>
  );
};

export default HeroSection;